import React from "react";
import ReactDOM from "react-dom";
import config from "./config/global";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
// import { login } from "./store/actions/authActions";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AppProvider from "./context/appContext";
import BusinessProvider from "./context/businessContext";
// import { useActions } from "./hooks/useActions";
// import setupInterceptors from "./services/setupInterceptors";

// const store = configureStore();
// const { login } = useActions();

// store.dispatch(login({ username: "ck@ck.com", password: "12wq" }));
// store.dispatch(authState());

if (config.env === "production") {
  const noconsole = () => true;
  console.log = noconsole;
  // console.warn = noconsole;
  // console.error = noconsole;
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppProvider>
        <BusinessProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </BusinessProvider>
      </AppProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// setupInterceptors(store);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
